import { Dispatch, SetStateAction, useCallback, useMemo } from "react";
import type { RemainingLine } from "./useRemainingLines";

export interface RemainingLineSetters {
    updateAccount: (id: string, accrualAccountId: string | null) => void;
    updateCashAccount: (id: string, cashAccountId: string | null) => void;
    updateCategory: (id: string, categoryId: string | null) => void;
    updateAmount: (id: string, amount: number) => void;
    updateDescription: (id: string, description: string) => void;
}

export function useRemainingLineSetters<T extends RemainingLine>(
    setLines: Dispatch<SetStateAction<T[]>>,
): RemainingLineSetters {
    const update = useCallback(
        (id: string, patch: Partial<RemainingLine>) => {
            setLines((prev) =>
                prev.map((line) =>
                    line.id === id ? { ...line, ...patch } : line,
                ),
            );
        },
        [setLines],
    );

    return useMemo(
        () => ({
            updateAccount: (id, accrualAccountId) =>
                update(id, { accrualAccountId }),
            updateCashAccount: (id, cashAccountId) =>
                update(id, { cashAccountId }),
            updateCategory: (id, categoryId) => update(id, { categoryId }),
            updateAmount: (id, amount) => update(id, { amount }),
            updateDescription: (id, description) => update(id, { description }),
        }),
        [update],
    );
}
